import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-hulp-vervoer',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconHulpVervoer {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M32.67.01H18.34c-1.84-.01-3.33 1.5-3.33 3.37v24.55c0 .59.47 1.07 1.07 1.07h1.86c.59 0 1.07-.48 1.07-1.07V26h13v1.93c0 .59.48 1.07 1.07 1.07h1.86c.59 0 1.07-.48 1.07-1.07V3.4C36 1.53 34.51.01 32.67.01M20 2.01h11v2H20zM18.5 22c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m14.01-.08c-.82 0-1.49-.66-1.49-1.46S31.69 19 32.51 19s1.49.66 1.49 1.46-.67 1.46-1.49 1.46M34 15H17V6.01h17v9ZM1.85 13.84c0-1.64 1.35-2.99 2.99-2.99s2.99 1.35 2.99 2.99-1.35 2.99-2.99 2.99-2.99-1.35-2.99-2.99m8.16 7.27V27c0 .55-.46 1-1.01 1H8v7c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-7H1c-.55 0-1-.45-1-1v-5.89c0-1.69 1.23-3 2.84-3.09h4.23c1.66.03 2.94 1.37 2.94 3.09"/>
</svg>

    );
  }
}
